import Type from './Type';
export function isIVocabulary(track) {
    return track.type === Type.Vocabulary;
}
export default isIVocabulary;    //# sourceMappingURL=isIVocabulary.js.map
